const Type = {
  Album: "album",
  Single: "single",
  Video: "video",
};
class Lightbox {
  constructor(type, callEl, callback = () => {}) {
    this.type = type;
    this.el = null;
    this.callEl = callEl;
    this.callEls = null;
    this.closeEl = null;
    this.className = "hc-lightbox";
    this.contentEl = null;
    this.assetUrl = "/assets/img/pro/";
    this.avatarEl = null,
    this.imgEl = Object.assign(document.createElement("img"), {
      width: "1000",
      height: "1000",
      src: "",
      alt: "image",
      loading: "lazy",
    });
    this.youtubeEl = null;
    this.playerBoxEl = null;
    this.playerEl = null;
    this.imgEls = null;
    this.index = 0;
    this.prevEl = null;
    this.nextEl = null;
    this.Init();
    this.callback = callback();
  }

  Icon(id) {
    let el = document.createElementNS("http://www.w3.org/2000/svg", "svg"),
      useEl = document.createElementNS("http://www.w3.org/2000/svg", "use");
    useEl.setAttribute("href", this.assetUrl + "icon/icons.svg#" + id);
    el.appendChild(useEl);
    return el;
  }

  AlbumFadeIn() {
    this.imgEl.classList.remove("fade-out");
    this.imgEl.classList.add("fade-in");
  }

  AlbumFadeOut() {
    this.imgEl.classList.remove("fade-in");
    this.imgEl.classList.add("fade-out");
    setTimeout(() => {
      this.imgEl.src = this.imgEls[this.index].dataset.src;
      this.AlbumFadeIn();
    }, 250);
  }

  AlbumNext() {
    this.nextEl.addEventListener("click", (e) => {
      if (this.index < this.imgEls.length - 1) {
        this.index++;
      } else {
        this.index = 0;
      }
      this.AlbumFadeOut();
    });
  }

  AlbumPrev() {
    this.prevEl.addEventListener("click", (e) => {
      if (this.index > 0) {
        this.index--;
      } else {
        this.index = this.imgEls.length - 1;
      }
      this.AlbumFadeOut();
    });
  }

  AlbumShow(el) {
    el.addEventListener("click", (e) => {
      this.el.classList.add("show");
      this.imgEls = el.querySelectorAll(".jsLightboxImg");
      this.index = 0;
      this.imgEl.src = this.imgEls[0].dataset.src;
      if (this.imgEls.length <= 1) {
        this.nextEl.classList.add("hidden");
        this.prevEl.classList.add("hidden");
      } else {
        this.nextEl.classList.remove("hidden");
        this.prevEl.classList.remove("hidden");
      }
      e.preventDefault();
    });
  }

  Album() {
    this.callEls = document.querySelectorAll(".jsLightboxCall");
    if (this.callEls) {
      this.avatarEl = Object.assign(document.createElement("div"), {
        className: this.className + "__item",
      });
      this.avatarEl.append(this.imgEl);
      this.contentEl.append(this.avatarEl);
      this.callEls.forEach((callEl) => {
        this.AlbumShow(callEl);
      });
    }
    this.closeEl.classList.add("position-fixed");
    this.el.append(this.closeEl);
    this.prevEl = this.Icon("i-arrow-left");
    this.prevEl.classList.add(
      this.className + "__arrow--prev",
      "position-absolute",
      "he-icon"
    );
    this.nextEl = this.Icon("i-arrow-left");
    this.nextEl.classList.add(
      this.className + "__arrow--next",
      "position-absolute",
      "he-icon"
    );
    this.contentEl.append(this.prevEl);
    this.contentEl.append(this.nextEl);
    this.AlbumPrev();
    this.AlbumNext();
  }

  Single() {
    if (this.callEl.dataset.href) {
      this.avatarEl = Object.assign(document.createElement("a"), {
        className: this.className + "__avatar",
        href: this.callEl.dataset.href,
      });
    }
    this.avatarEl.append(this.imgEl);
    this.contentEl.append(this.avatarEl);
    this.closeEl.classList.add("position-absolute");
    this.contentEl.append(this.closeEl);
    if (this.callEl.dataset.state) {
      this.el.classList.add(this.callEl.dataset.state);
    }
    if (this.callEl.dataset.src) {
      this.imgEl.src = this.callEl.dataset.src;
    }
    console.log(this.el);
  }

  YoutubePlay(id) {
    if (this.youtubeEl) {
      this.youtubeEl.loadVideoById(id);
      this.youtubeEl.playVideo();
    }
  }

  YoutubeStop() {
    if (this.youtubeEl) {
      this.youtubeEl.stopVideo();
    }
  }

  VideoShow(el) {
    el.addEventListener("click", (e) => {
      this.el.classList.add("show");
      this.YoutubePlay(el.dataset.id);
      e.preventDefault();
    });
  }

  Video() {
    this.callEls = document.querySelectorAll(".jsLightboxVideoCall");
    if (this.callEls) {
      this.playerBoxEl = Object.assign(document.createElement("div"), {
        className: this.className + "__video",
      });
      this.playerEl = document.createElement("div");
      this.playerBoxEl.append(this.playerEl);
      this.contentEl.append(this.playerBoxEl);
      this.youtubeEl = new YT.Player(this.playerEl, {
        width: "100%",
        videoId: "WCriHDs_MJs",
        autoplay: 0,
        events: {
          onReady: (e) => {
            e.target.stopVideo();
          },
        },
      });
      this.callEls.forEach((callEl) => {
        this.VideoShow(callEl);
      });
    }
    this.closeEl.classList.add("position-fixed");
    this.el.append(this.closeEl);
  }

  Close(el, type, youtubeEl) {
    el.addEventListener("click", function (e) {
      if (e.target.classList.contains("jsLightbox")) {
        el.classList.remove("show");
        switch (type) {
          case Type.Album: {
            this.index = 0;
            break;
          }
          case Type.Video: {
            youtubeEl.stopVideo();
            break;
          }
          default: {
            break;
          }
        }
      }
    });
    this.closeEl.addEventListener("click", function (e) {
      el.classList.remove("show");
      switch (type) {
        case Type.Album: {
          this.index = 0;
          break;
        }
        case Type.Video: {
          youtubeEl.stopVideo();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  Init() {
    this.el = document.createElement("div");
    this.el.classList.add(this.className + "--" + this.type, "jsLightbox");
    this.contentEl = Object.assign(document.createElement("div"), {
      className: this.className + "__content position-relative",
    });
    this.closeEl = this.Icon("i-close");
    this.closeEl.classList.add(this.className + "__close", "he-icon");
    this.el.append(this.contentEl);
    switch (this.type) {
      case Type.Album: {
        this.Album();
        break;
      }
      case Type.Single: {
        this.Single();
        break;
      }
      case Type.Video: {
        this.Video();
        break;
      }
      default: {
        break;
      }
    }
    document.getElementsByTagName("body")[0].append(this.el);
    this.Close(this.el, this.type, this.youtubeEl);
  }
}

window.addEventListener("load", (e) => {
  let lightboxAlbum = new Lightbox(Type.Album);
  let lightboxVideo = new Lightbox(Type.Video);
  let lightboxPromotionEl = document.getElementById("jsLightboxPromotion");
  if (lightboxPromotionEl) {
    let lightboxSingle = new Lightbox(Type.Single, lightboxPromotionEl);
  }
});
